"use strict";
/** Переиспользуемые примитивы валидации с сообщениями на русском языке. */
Object.defineProperty(exports, "__esModule", { value: true });
exports.cursorPageSchema = exports.markdownSchema = exports.isoDateSchema = exports.passwordSchema = exports.emailSchema = exports.uuidSchema = void 0;
exports.emptyToNull = emptyToNull;
const contracts_1 = require("@project-os/contracts");
const zod_1 = require("zod");
exports.uuidSchema = zod_1.z.uuid('Некорректный идентификатор');
exports.emailSchema = zod_1.z
    .string()
    .trim()
    .toLowerCase()
    .min(3, 'Укажите адрес электронной почты')
    .max(320, 'Адрес не длиннее 320 символов')
    .refine((value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value), 'Некорректный адрес');
/**
 * Требования к паролю. Проверяется только длина: сложность, навязанная
 * правилами состава символов, на практике снижает качество паролей.
 */
exports.passwordSchema = zod_1.z
    .string()
    .min(12, 'Пароль не короче 12 символов')
    .max(200, 'Пароль не длиннее 200 символов');
exports.isoDateSchema = zod_1.z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/, 'Дата в формате ГГГГ-ММ-ДД')
    .refine((value) => !Number.isNaN(Date.parse(value)), 'Несуществующая дата');
/** Markdown-содержимое элемента. Отрисованный HTML источником данных не является. */
exports.markdownSchema = zod_1.z.string().max(100_000, 'Текст слишком длинный');
exports.cursorPageSchema = zod_1.z.object({
    cursor: zod_1.z.string().max(500).optional(),
    limit: zod_1.z.coerce
        .number()
        .int()
        .min(1, 'Размер страницы не меньше 1')
        .max(contracts_1.MAX_PAGE_SIZE, `Размер страницы не больше ${contracts_1.MAX_PAGE_SIZE}`)
        .default(contracts_1.DEFAULT_PAGE_SIZE),
});
/** Пустая строка из формы означает «значение не задано». */
function emptyToNull(schema) {
    return zod_1.z.preprocess((value) => (value === '' ? null : value), schema.nullable());
}
//# sourceMappingURL=common.js.map